@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../constants/spacing.module.less';
@import '../../../../constants/screen-width-breakpoints.module.less';

@progressWidth: 315px;
@footerHeight: 65px;
@ftu-header-offset: 169px; // Height of header + navigation + any other fixed elements

.ftu-wizard-footer {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: @space-16 @space-24;
  box-shadow: 4px 0 4px 0 rgba(0, 0, 0, 0.25);
  border-top: 1px solid var(--grey-300);
  position: absolute;
  bottom: 0;
  background-color: @white;

  &.no-back-button {
    justify-content: flex-end;
  }

  @media @mobile {
    padding: @space-12 @space-16;

    .back-button {
      display: none;
    }

    &.no-back-button {
      justify-content: flex-end;
    }

    &:not(.no-back-button) {
      justify-content: flex-end;
    }

    &.skip-only-right-aligned {
      justify-content: unset;

      > div {
        width: 100%;

        .skip-button {
          width: 100%;
        }
      }
    }

    &.continue-only-right-aligned {
      justify-content: unset;

      > div {
        width: 100%;

        button {
          width: 100%;
        }
      }
    }

    &.two-buttons-right-aligned {
      justify-content: unset;

      > div {
        width: 100%;
        display: flex;
        gap: @space-16;

        button {
          flex: 1;
        }
      }
    }
  }

  @media only screen and (min-width: 752px) {
    &.skip-only-right-aligned,
    &.continue-only-right-aligned,
    &.two-buttons-right-aligned {
      justify-content: space-between;

      > div {
        display: flex;
        gap: @space-16;

        button {
          width: auto;
          flex: none;
        }
      }
    }
  }
}

.skip-button {
  margin-right: @space-16;
}

.back-button {
  display: flex;
  gap: 6px;
  align-items: center;
  svg {
    width: 14px;
    height: 14px;
  }
}

.ftu-wizard-pane {
  display: grid;
  grid-template-columns: @progressWidth 1fr;
  width: 100%;
  height: 100%;
  align-items: self-start;

  @media @mobile {
    display: flex;
    flex-direction: column;
    grid-template-columns: none;
    grid-template-rows: none;
  }
}

.ftu-wizard-progress {
  background-color: var(--green-00331C);
  padding: @space-40;
  max-width: @progressWidth;
  height: calc(100vh - @ftu-header-offset);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;

  @media @mobile {
    overflow: hidden;
    max-width: none;
    width: 100%;
    height: 100px;
    padding: @space-12 @space-16;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    order: 1;
    background-color: var(--white);
  }
}

.ftu-wizard-stepper {
  display: flex;
  justify-content: center;
  margin: @space-40 0;

  @media @mobile {
    margin: 0;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
}

.ftu-wizard-help-center {
  margin-top: @space-64;
  margin-bottom: @space-40;

  @media @mobile {
    display: none;
  }
}

.ftu-wizard-content {
  background-color: var(--gray-F7F7F8);
  text-align: center;
  padding: @space-40 @space-0 calc(@space-40 + @footerHeight);
  height: calc(100% - 60px);
  overflow: auto;

  @media @mobile, @ultramobile {
    padding: @space-24 @space-16 calc(@space-24 + @footerHeight);
    height: calc(100vh - @ftu-header-offset - 68px - 65px - 24px);
    flex: 1;
    order: 2;
    overflow-x: auto;
  }
}

.drawer-canvas {
  background-color: var(--white);
}

.ftu-drawer {
  .custom-header {
    background-color: var(--white);
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 40px;
    padding: @space-8 @space-16;
    font-size: 14px;
    line-height: 24px;
    border-bottom: 1px solid var(--default--border-color--12);
    gap: @space-8;
  }

  .header-button {
    svg {
      width: 16px;
      height: 16px;
      color: var(--gray-333333);
    }
  }

  .header-title {
    flex: 1;
    text-align: center;
  }
}

.ftu-drawer-header {
  background-color: var(--white);
}
